export const allPeriod = [
  "Day",
  "Week",
  "Monthly",
  `Quarterly, ending "Mar, June, Sep, Dec"`,
  "Ten",
  `Annual, ending "Dec" of each year`,
  `Annual, ending "Mar" of each year`,
  `Annual, ending "May" of each year`,
  `Half-yearly ending "Jun, Dec"`,
  `Half-yearly ending "Jul, Jan"`,
  `Annual, ending "Aug" of each year`,
  `Annual, ending "Sep" of each year`,
  `Annual, ending "Oct" of each year`,
  `Half Year, ending "Jun, Dec"`,
  `Half year, ending "Jan, Jul"`,
  `Quarterly, ending "Feb, May, Aug, Nov"`,
  `Quarterly, ending "Jan, Apr, Jul, Oct"`,
  "Half Monthly",
  "Irregular"
];

export const allPeriodList = [
  {
    label: "Day",
    field: "日"
  },
  {
    label: "Week",
    field: "周"
  },
  {
    label: "Monthly",
    field: "月"
  },
  {
    label: `Quarterly, ending "Mar, June, Sep, Dec"`,
    field: "季"
  },
  {
    label: "Ten",
    field: "旬"
  },
  {
    label: `Annual, ending "Dec" of each year`,
    field: "年"
  },
  {
    label: `Annual, ending "Mar" of each year`,
    field: "年按3月"
  },
  {
    label: `Annual, ending "May" of each year`,
    field: "年按5月"
  },
  {
    label: `Half-yearly ending "Jun, Dec"`,
    field: "年按6月"
  },
  {
    label: `Half-yearly ending "Jul, Jan"`,
    field: "年按7月"
  },

  {
    label: `Annual, ending "Aug" of each year`,
    field: "年按8月"
  },
  {
    label: `Annual, ending "Sep" of each year`,
    field: "年按9月"
  },
  {
    label: `Annual, ending "Oct" of each year`,
    field: "年按10月"
  },

  {
    label: `Half Year, ending "Jun, Dec"`,
    field: "半年"
  },
  {
    label: `Half year, ending "Jan, Jul"`,
    field: "半年按7,1月"
  },

  {
    label: `Quarterly, ending "Feb, May, Aug, Nov"`,
    field: "季按2,5,8,11月"
  },
  {
    label: `Quarterly, ending "Jan, Apr, Jul, Oct"`,
    field: "季按1,4,7,10月"
  },
  {
    label: "Half Monthly",
    field: "半月"
  },
  {
    label: "Irregular",
    field: "不定期"
  },
]
